import { LoginOutlined } from "@ant-design/icons"
import { Button, Card, Form, Input } from "antd"
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { LoginUser } from "../store/slices/authSlice";

const Login = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const loginClick = async (values) => {
        setLoading(true);
        setErrorMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const resultAction = await dispatch(LoginUser({ email: values.email, password: values.password }));

            if (LoginUser.fulfilled.match(resultAction)) {
                navigate('/dashboard');
            } else {
                setErrorMessage(resultAction?.payload?.error || 'Login failed');
            }
        } catch (error) {
            setErrorMessage('Login failed. Please try again.');
            console.log(error)
        } finally {
            setLoading(false);
        }
    }
    return (
        <div style={{
            minHeight: '100vh',
            background: 'rgb(44, 50, 58)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            position: 'relative',
        }}>
            {/* Decorative circles */}
            <div style={{
                position: 'absolute',
                top: '10%',
                left: '10%',
                width: '200px',
                height: '200px',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                filter: 'blur(40px)',
            }}></div>
            <div style={{
                position: 'absolute',
                bottom: '10%',
                right: '10%',
                width: '300px',
                height: '300px',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                filter: 'blur(60px)',
            }}></div>

            <Card
                style={{
                    maxWidth: 450,
                    width: '100%',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                    borderRadius: '16px',
                    background: '#fff',
                    border: 'none',
                    position: 'relative',
                    zIndex: 1,
                }}
                bodyStyle={{
                    padding: '48px 40px',
                }}
            >
                {/* <TojuCareLogo /> */}

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={loginClick}
                    autoComplete="off"
                    size="large"
                >
                    {errorMessage && (
                        <div style={{
                            marginBottom: '16px',
                            padding: '12px',
                            background: '#fff2f0',
                            border: '1px solid #ffccc7',
                            borderRadius: '6px',
                            color: '#cf1322',
                            fontSize: '14px',
                            textAlign: 'center',
                        }}>
                            {errorMessage}
                        </div>
                    )}

                    <Form.Item
                        label={<span style={{ fontWeight: 500 }}>Email</span>}
                        name="email"
                        rules={[
                            { required: true, message: 'Please enter your email' },
                            { type: 'email', message: 'Please enter a valid email' }
                        ]}
                    >
                        <Input
                            placeholder="Enter your email address"
                            style={{ height: '44px' }}
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span style={{ fontWeight: 500 }}>Password</span>}
                        name="password"
                        rules={[
                            { required: true, message: 'Please enter your password' },
                            { min: 6, message: 'Password must be at least 6 characters' }
                        ]}
                        style={{ marginBottom: '24px' }}
                    >
                        <Input.Password
                            placeholder="Enter your password"
                            style={{ height: '44px' }}
                        />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            icon={<LoginOutlined />}
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                        >
                            Sign In
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    )
}

export default Login